import type { ReactNode } from "react";

interface SectionProps {
  title: string;
  description?: string;
  right?: ReactNode;
  children: ReactNode;
}

export const Section = ({ title, description, right, children }: SectionProps) => (
  <section className="section">
    <header className="section-head">
      <div>
        <h2>{title}</h2>
        {description && <p className="section-desc">{description}</p>}
      </div>
      {right != null && <div className="section-right">{right}</div>}
    </header>
    <div className="section-body">{children}</div>
  </section>
);
